import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router';
import { PERMISSIONS } from '@auth/permissions';
import { RequirePermission } from '@routes/RequirePermission';

const MemberDetails = lazy(() =>
  import('@pages/Management/Members/MemberDetails').then((m) => ({
    default: m.MemberDetails,
  }))
);

const MembersOverview = lazy(() =>
  import('@pages/Management/Members/MembersOverview').then((m) => ({
    default: m.MembersOverview,
  }))
);

const UpsertMember = lazy(() =>
  import('@pages/Management/Members/UpsertMember').then((m) => ({
    default: m.UpsertMember,
  }))
);

export const manageMembersRoutes = (
  <Route element={<RequirePermission permission={PERMISSIONS.members.view} />}>
    <Route path="members">
      <Route index element={<Navigate to="overview" replace />} />

      <Route path="overview">
        <Route index element={<MembersOverview />} />

        <Route
          element={
            <RequirePermission permission={PERMISSIONS.members.create} />
          }
        >
          <Route path="new" element={<UpsertMember />} />
        </Route>

        <Route
          element={
            <RequirePermission permission={PERMISSIONS.members.update} />
          }
        >
          <Route path="edit/:slug" element={<UpsertMember />} />
        </Route>

        <Route path=":slug" element={<MemberDetails />} />
      </Route>
    </Route>
  </Route>
);
